import * as lazy from "./lazyRouteComponents";

export default [
  {
    path: "",
    name: "superAdmin:dashboard",
    component: lazy.Dashboard
  },
  {
    path: "companies",
    name: "superAdmin:companyList",
    component: lazy.CompanyList
  },
  {
    path: "companies/:companyId/edit",
    name: "superAdmin:companyEdit",
    component: lazy.EditCompany
  },
  {
    path: "companies/new",
    name: "superAdmin:companyCreate",
    component: lazy.CreateCompany
  }
];
